"use client";

import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

const RadixCollapsible = CollapsiblePrimitive as any;
const hasRadixCollapsible =
  typeof (RadixCollapsible as any)?.Root !== "undefined" &&
  typeof (RadixCollapsible as any)?.Trigger !== "undefined" &&
  typeof (RadixCollapsible as any)?.Content !== "undefined";

let hasWarnedMissingRadixCollapsible = false;
const warnMissingRadixCollapsible = () => {
  if (hasWarnedMissingRadixCollapsible) return;
  hasWarnedMissingRadixCollapsible = true;
  console.warn(
    "[ui/collapsible] Radix Collapsible primitives unavailable. Falling back to basic markup.",
  );
};

function Collapsible({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Root>) {
  if (!hasRadixCollapsible) {
    warnMissingRadixCollapsible();
    const { open, defaultOpen, onOpenChange, disabled, ...rest } = props as any;
    return (
      <div
        data-slot="collapsible-fallback"
        aria-disabled={disabled}
        {...rest}
      />
    );
  }
  return <RadixCollapsible.Root data-slot="collapsible" {...props} />;
}

function CollapsibleTrigger({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Trigger>) {
  if (
    !hasRadixCollapsible ||
    typeof (RadixCollapsible as any)?.Trigger === "undefined"
  ) {
    warnMissingRadixCollapsible();
    const { asChild, disabled, ...rest } = props as any;
    return (
      <button
        data-slot="collapsible-trigger-fallback"
        type="button"
        disabled={disabled}
        {...rest}
      />
    );
  }
  return (
    <RadixCollapsible.Trigger
      data-slot="collapsible-trigger"
      {...props}
    />
  );
}

function CollapsibleContent({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Content>) {
  if (
    !hasRadixCollapsible ||
    typeof (RadixCollapsible as any)?.Content === "undefined"
  ) {
    warnMissingRadixCollapsible();
    const { forceMount, ...rest } = props as any;
    return <div data-slot="collapsible-content-fallback" {...rest} />;
  }
  return (
    <RadixCollapsible.Content
      data-slot="collapsible-content"
      {...props}
    />
  );
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
